import type { AgentApiJobSourcesService } from '@/types/serializers';
import { Button } from '@/components/Button';
import { MdKeyboardArrowLeft } from 'react-icons/md';

type Props = {
  groupName: string;
  services: AgentApiJobSourcesService[];
  onSelect: (service: AgentApiJobSourcesService) => void;
  onBack?: () => void;
};

export default function LinkedAccountSourceMethodSelect({
  groupName,
  services,
  onSelect,
  onBack,
}: Props) {
  return (
    <div className="relative z-10 mt-sm flex flex-col items-center gap-x3l">
      <div className="flex flex-col items-center gap-3">
        <p className="text-center text-heading-xl">{groupName}の追加方法を選択</p>
      </div>
      <div className="flex items-center justify-center gap-md">
        {services.map((service) => (
          <button
            key={service.source_type}
            type="button"
            className="flex size-[270px] cursor-pointer flex-col items-center justify-center gap-xl rounded-lg border-0 bg-white p-md shadow-layer1 hover:opacity-60"
            onClick={() => onSelect(service)}
          >
            <div className="h-[51px] w-[154px]">
              <img
                src={service.image_url}
                alt=""
                width={154}
                height={51}
                className="size-full object-contain"
              />
            </div>
            <div className="flex flex-col items-center justify-center gap-xs">
              <p className="text-center text-heading-sm">{service.name}</p>
              <p className="text-center text-body-sm whitespace-pre-wrap">
                {service.description.replace(/お持ちの方/g, '\nお持ちの方')}
              </p>
            </div>
          </button>
        ))}
      </div>
      {onBack && (
        <Button
          type="button"
          color="secondary"
          className="h-[52px] w-[224px] gap-xs"
          onClick={onBack}
        >
          <MdKeyboardArrowLeft size={20} />
          アカウント選択へ戻る
        </Button>
      )}
    </div>
  );
}
